setTimeout(function() {
    if (!customElements.get('product-filter')) {
        customElements.define('product-filter', class Filter extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                let _this = this;
                this.dataset.urlCollection = location.search;

                this.debouncedOnChange = debounce((event) => {
                    event.preventDefault();
                    this.formSubmit(event);
                }, 200);

                $('select#sort-by').on('change', function(e) {
                    _this.formSubmit(e);
                });

                this.form.addEventListener('submit', this.formSubmit.bind(this));

                this.querySelector('.js-clear-filters')?.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.clearFilters();
                });
            }

            clearFilters() {
                const url = this.getAttribute('data-url');
                const sectionId = this.getAttribute('data-section');

                this.form.querySelectorAll('input[type="checkbox"]').forEach(input => {
                    input.checked = false;
                });

                this.form.querySelectorAll('select').forEach(select => {
                    select.selectedIndex = 0;
                });

                document.querySelector('[data-loaning]').classList.add('loading');

                fetch(url + '?section_id=' + sectionId)
                .then(res => res.text())
                .then(responseText => {
                    const doc = new DOMParser().parseFromString(responseText, 'text/html');

                    const newGrid = doc.querySelector('[data-product-grid]');
                    const grid = document.querySelector('[data-product-grid]');
                    if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;

                    const fetchWrapper = doc.querySelector('[data-product-pagination-wrapper]');
                    const wrapper = document.querySelector('[data-product-pagination-wrapper]');
                    if (fetchWrapper) {
                      if (wrapper) wrapper.innerHTML = fetchWrapper.innerHTML;
                      else grid.insertAdjacentElement('afterend', fetchWrapper);
                    } else if (wrapper) wrapper.remove();

                    const newSort = doc.querySelector('[data-product-sort]');
                    const sort = document.querySelector('[data-product-sort]');
                    if (newSort && sort) sort.innerHTML = newSort.innerHTML;

                    const newCount = doc.querySelector('[data-product-count]');
                    const count = document.querySelector('[data-product-count]');
                    if (newCount && count) count.innerHTML = newCount.innerHTML;

                    window.history.replaceState({}, '', url);

                    document.querySelector('[data-loaning]').classList.remove('loading');
                    document.dispatchEvent(new Event('collection:updated'));

                    // this.querySelector('.js-side-panel-close').click();
                });
            }

            formSubmit(evt) {
                evt.preventDefault();
                document.querySelector('[data-loaning]').classList.add('loading');

                const formData = new FormData(evt.target.closest('form'));
                const searchParams = new URLSearchParams(formData).toString();
                const url = this.getAttribute('data-url');
                const urlCollection = this.dataset.urlCollection;
                const sectionId = this.getAttribute('data-section');

                this.updateContent(url, searchParams, sectionId, urlCollection);
            }

            updateContent(url, searchParams, section, urlCollection) {
                let fetchUrl = searchParams.includes('sort_by') ?
                  (urlCollection.includes('filter') ? urlCollection.split('&sort_by')[0] + '&' + searchParams + '&section_id=' + section
                                                    : url + '?' + searchParams + '&section_id=' + section)
                  : url + '?' + searchParams + '&section_id=' + section;

                fetch(fetchUrl)
                  .then(res => res.text())
                  .then(responseText => {
                    const doc = new DOMParser().parseFromString(responseText, 'text/html');

                    const newGrid = doc.querySelector('[data-product-grid]');
                    const grid = document.querySelector('[data-product-grid]');
                    if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;

                    const fetchWrapper = doc.querySelector('[data-product-pagination-wrapper]');
                    const wrapper = document.querySelector('[data-product-pagination-wrapper]');
                    if (fetchWrapper) {
                      if (wrapper) wrapper.innerHTML = fetchWrapper.innerHTML;
                      else grid.insertAdjacentElement('afterend', fetchWrapper);
                    } else if (wrapper) wrapper.remove();

                    const newSort = doc.querySelector('[data-product-sort]');
                    const sort = document.querySelector('[data-product-sort]');
                    if (newSort && sort) sort.innerHTML = newSort.innerHTML;

                    const newCount = doc.querySelector('[data-product-count]');
                    const count = document.querySelector('[data-product-count]');
                    if (newCount && count) count.innerHTML = newCount.innerHTML;

                    const newFilter = doc.querySelector('[data-product-filter]');
                    const filter = document.querySelector('[data-product-filter]');
                    if (newFilter && filter) filter.closest('.filter-panel').querySelector('.js-side-panel-close').click();

                    if (document.querySelector('[data-url-collection]')) document.querySelector('[data-url-collection]').dataset.urlCollection = fetchUrl.split('&section')[0];

                    $('select').selectric({ disableOnMobile: false, nativeOnMobile: false });
                    window.history.replaceState({}, '', fetchUrl.split('&section')[0]);

                    document.querySelector('[data-loaning]').classList.remove('loading');
                    document.dispatchEvent(new Event('collection:updated'));
                  })
                  .catch(err => console.error('Something went wrong.', err));
              }
        });
    }

    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}, 500);